import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HelperService,ErrorClass } from '../../api/helper.service'
import { TopClass } from '../../class/topclass'
import { HomeService } from '../../api/home.service'

declare var $:any;
@Component({
  selector: 'app-top-list',
  templateUrl: './top-list.component.html',
  styleUrls: ['./top-list.component.css']
})
export class TopListComponent implements OnInit {
  defaultImage = '../assets/images/image_not_available.jpg';
  isBrowser:boolean;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private api: HomeService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  fd_list:TopClass[] = []
  dr_list:TopClass[] = []

  
  ngOnInit() {
     this.loadTopList()
  }

  loadTopList(){
    this.api.getTopList().subscribe(
      (data) => {
         this.fd_list = data['top_fundraiser'],
         this.dr_list = data['top_donor']
      }
    )
  }
    
    // this.FundraisingWorksConfig = {
    //   grid: { xs: 1, sm: 2, md: 3, lg: 4, all: 0 },
    //   slide: 1,
    //   speed: 400,
    //   interval: {
    //     timing: 3000,
    //     initialDelay: 1000
    //   },
    //   point: {
    //     visible: true
    //   },
    //   load: 2,
    //   loop: true,
    //   touch: true
    // };

    
  

}
